import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsETAStyles {
    title?: TypographyProps;
    text?: TypographyProps;
}

export const productDetailsETAStyles: ProductDetailsETAStyles = {
    title: {
        weight: TYPOGRAPHY.weight.bold,
        color: COLORS.text.dark,
        size: TYPOGRAPHY.size.small,
    },
    text: {
        color: COLORS.text.dark,
        size: TYPOGRAPHY.size.small,
        css: css`
            margin-left: 5px;
        `,
    },
};

const styles = productDetailsETAStyles;

const ProductDetailsETA = ({ product }: Props) => {
    if (!product.properties.eta) {
        return null;
    }

    const productETA = product.properties.eta;

    return (
        <StyledWrapper>
            <Typography {...styles.title}>{translate("ETA :")}</Typography>
            <Typography {...styles.text}>{productETA}</Typography>
        </StyledWrapper>
    );
};

const storeProductDetailsETA: WidgetModule = {
    component: withProduct(ProductDetailsETA),
    definition: {
        displayName: "ETA",
        group: "Product Details",
    },
};

export default storeProductDetailsETA;
